import { AccountSearchResult } from 'src/features/bulk/email/search/store/types';
import { SavedParameter } from 'src/features/clients/client/reportsV2/store/types';
import { ClientItem } from 'src/features/clients/list/store/types';
import { AdviserItem, AfslItem, GroupItem, PracticeItem, ScheduledEvent, ScheduledEventInput } from 'src/features/reporting/store/types';

export interface SchedulerState {
  afsls: AfslItem[];
  groups: GroupItem[];
  clients: ClientItem[];
  practices: PracticeItem[];
  advisers: AdviserItem[];
  savedParametersList: SavedParameter[];
  editingEvent?: ScheduledEvent | null;
  savedParameter: SavedParameterWithAfsl | null;
  selectedTemplate?: EmailTemplate;
  accountSearchResult: AccountSearchResult[];
  allowStaticClients: boolean;
  afslTemplates: AfslTemplate[];
  practiceTemplates: PracticeTemplate[];
}

export interface SavedParameterWithAfsl {
  id: string;
  name: string;
  afslId: number;
}

export interface SchedulerParams {
  id?: string;
}

export interface ReportingParametersParams {
  id?: string;
}

export type SchedulerStep = 'schedule' | 'client' | 'report' | 'email';

export interface UpdateScheduledEventRequest {
  id: string;
  input: ScheduledEventInput;
}

export enum FromEmailAddressType {
  DASH = 'DASH',
  Adviser = 'Adviser',
}

export interface TemplatesRequest {
  entityCoreIds: number[];
}

export interface EmailTemplate {
  id: number;
  entityCoreId: number;
  templateName: string;
  templateText: string;
  emailSubject: string;
  attachments: EmailAttachmentTemplate[];
  isDeleted: boolean;
}

export interface AfslTemplate {
  afslTemplateId: number;
  entityCoreId: number;
  templateName: string;
  templateText: string;
  emailSubject: string;
  attachments: EmailAttachmentTemplate[];
  isDeleted: boolean;
}

export interface EmailAttachmentTemplate {
  attachmentTypeId: number;
  extension: number;
  fileName: string;
  id: number;
  name: string;
}

export interface PracticeTemplate {
  practiceTemplateId: number;
  entityCoreId: number;
  templateName: string;
  templateText: string;
  emailSubject: string;
  attachments: EmailAttachmentTemplate[];
  isDeleted: boolean;
}
